import Data from 'data';
import { Seasons } from 'common';
import Locale from 'data/locale';

const _L = Locale("ui-skills.js", "skilldata");

export const cubeTypes = {
  weapon: {
    name: () => _L`Weapon`,
    filter(type) {
      const slot = Data.itemTypes[type] && Data.itemTypes[type].slot;
      return slot === "onehand" || slot === "twohand" || slot === "offhand";
    },
  },
  armor: {
    name: () => _L`Armor`,
    filter(type) {
      return !cubeTypes.weapon.filter(type) && !cubeTypes.jewelry.filter(type) && Data.itemTypes[type]?.slot;
    },
  },
  jewelry: {
    name: () => _L`Jewelry`,
    filter(type) {
      return type === "ring" || type === "amulet";
    },
  },
  extra: {
    name: () => _L`Extra`,
    filter(type) {
      return true;
    },
  },
};

export function cubeGetType(id) {
  const item = Data.itemById[id];
  if (!item) return;
  for (const type in cubeTypes) {
    if (cubeTypes[type].filter(item.type)) return type;
  }
}

export function cubeSlotValid(profile, type) {
  if (type === "extra" && profile.seasonal !== Seasons.Shadows) {
    return false;
  }
  return true;
}

export function cubeGetStat(id) {
  if (!id) return null;
  const item = Data.itemById[id];
  const stat = item && item.required && item.required.custom;
  if (!stat || !stat.id) return null;
  let args = stat.args;
  if (args === undefined) args = 1;
  if (args === 1) {
    return [stat.id, (stat.best === "min" ? stat.min : stat.max) || 1];
  } else {
    return [stat.id, 1];
  }
}

export function cubeGetStats(profile) {
  const result = {};
  for (const type in profile.kanai) {
    if (!cubeSlotValid(profile, type)) continue;
    if (!profile.kanai[type]) continue;
    const stat = cubeGetStat(profile.kanai[type]);
    if (stat) {
      result[stat[0]] = stat[1];
    }
  }
  return result;
}

export function cubeItemAllowed(profile, slot, id) {
  const item = Data.itemById[id];
  if (!item || !item.required || !item.required.custom || !item.required.custom.id || item.required.custom.cube === false) return false;
  if (item.classes && !item.classes.includes(profile.class)) return false;
  const type = Data.itemTypes[item.type];
  if (!type || (type.classes && !type.classes.includes(profile.class))) return false;
  const powerClass = Data.itemPowerClasses[item.required.custom.id];
  if (powerClass && powerClass !== profile.class) return false;
  if (item.required.custom.args < 0) return false;

  if (profile.seasonal !== Seasons.Archives && !cubeTypes[slot].filter(item.type)) {
    return false;
  }

  return true;
}
